import { incomeInfoApi } from "@/libs/api.js";
// import { uleUrl, uleCdn, getCookie } from "@/libs/common";
// import bottomPop from "@/components/yzg/bottomPop.vue";
export default {
  name: "income",
  data() {
    return {
      dateIndex: 0,
      show: false,
      showPicker: false,
      currentDateText: "今日",
      columns: [
        { text: "今日", dateRange: 1 },
        { text: "昨日", dateRange: 0 },
        { text: "7天", dateRange: 7 },
        { text: "30天", dateRange: 30 },
      ],
      currentDateRange: 1,
      tradingInfo: {},
      incomeSourceInfo: {},
      currentNav: 0,
      incomeInfo: {},
      currentYear: "",
    };
  },

  mounted() {
    let lastText = `${this.$moment(Date.now()).format("YYYY")}年至今`,
      firstDay = this.$moment().startOf("year"),
      lastDay = this.$moment().diff(this.$moment(firstDay), "day");
    this.columns.push({
      text: lastText,
      dateRange: lastDay,
    });
    this.currentYear = this.$moment(Date.now()).format("YYYY");
    this.getIncomeInfo();
  },
  methods: {
    onConfirm(value) {
      console.log(value.text);
      this.currentDateText = value.text;
      this.currentDateRange = value.dateRange;
      this.showPicker = false;
      this.getIncomeInfo();
    },
    handleChangNav(index) {
      this.currentNav = index;
    },
    // 创业收益
    getIncomeInfo() {
      this.$toast.loading({
        duration: 0,
        mask: true,
        message: "加载中...",
      });
      let query = {
        dateRange: this.currentDateRange,
        clientCallType: "H5",
      };
      incomeInfoApi(query).then((res) => {
        this.$toast.clear();
        if (res.returnCode == "0000") {
          this.incomeInfo = res.data;
        }
      });
    },
    handleBackApp() {
      location.href = "ulemobile://ulePopView";
    },
  },
};
